// Utility function to get environment variables from appropriate location
import { getEnvVar } from './datahooks/metadata/EnvUtils';

export const API_BASE_URL = getEnvVar('VITE_API_BASE_URL');
export const API_ADMIN_URL = getEnvVar('VITE_API_ADMIN_URL');
export const FUNCTION_KEY = getEnvVar('VITE_FUNCTION_KEY');

export const PROJECT_SCOPE = getEnvVar('VITE_PROJECT_SCOPE');

export const DC_API_BASE_URL = getEnvVar('VITE_DC_API_BASE_URL');

export const IMAGES_URL = getEnvVar('VITE_IMAGE_BASE_URL');
export const PRIVATE_IMAGES = getEnvVar('VITE_PRIVATE_IMAGES', false);

export const APP_ENVIRONMENT = getEnvVar('VITE_APP_ENVIRONMENT','Production');
export const SENTRY_DSN = getEnvVar('VITE_SENTRY_DSN');

export const IS_DEBUG = getEnvVar('VITE_IS_DEBUG', false);

export const MSAL_RESET_URL = getEnvVar('VITE_MSAL_RESET');

export const MSAL_CONFIG = {
  auth: {
    clientId: getEnvVar('VITE_MSAL_CLIENT_ID'),
    authority: getEnvVar('VITE_MSAL_AUTHORITY'),
    knownAuthorities: [getEnvVar('VITE_MSAL_KNOWN_AUTHORITIES')],
    redirectUri: getEnvVar('VITE_MSAL_REDIRECT_URI'),
    postLogoutRedirectUri: getEnvVar('VITE_MSAL_POST_LOGOUT_REDIRECT_URI')
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: true,
  },
};

export const IS_DEV_MODE = APP_ENVIRONMENT === 'Local Development';

export const NOTIFICATIONS_ENABLED = getEnvVar('VITE_NOTIFICATIONS_ENABLED', false) === 'true';

// Colour settings
export const COLOURS = {
  pass: 'var(--pass-green)',   // Same as --green-500
  fail: 'var(--highlight)',   // Same as --highlight
  highlight: 'var(--highlight)', // Same as --highlight
  highlight2: 'var(--highlight2)', // Same as --highlight2
  brand: 'var(--brand-color)',
  errors: 'var(--errors)',
};

// Image upload settings
export const IMAGE_UPLOAD = {
  MAX_SIZE: Number(getEnvVar('VITE_MAX_IMAGE_SIZE', '204800')), // 200KB max
  ALLOWED_TYPES: getEnvVar('VITE_ALLOWED_IMAGE_TYPES', 'image/jpeg,image/png,image/gif,image/webp').split(',')
};

export const CLARITY_ID = getEnvVar('VITE_CLARITY_ID', '');
export const CLARITY_ENABLED = getEnvVar('VITE_ENABLE_CLARITY', false) === 'true';

export const ENABLE_EVENT_SUMMARY = getEnvVar('VITE_ENABLE_EVENT_SUMMARY', false) === 'true';
export const ENABLE_EVENT_SUMMARY_PROJTEST_CHART = getEnvVar('VITE_ENABLE_EVENT_SUMMARY_PROJTEST_CHART', false) === 'true';
export const ENABLE_EVENT_SUMMARY_ADVANCED_FILTERS = getEnvVar('VITE_ENABLE_EVENT_SUMMARY_ADVANCED_FILTERS', false) === 'true';
export const ENABLE_AI_EXPLAINER = getEnvVar('VITE_ENABLE_AI_EXPLAINER', false) === 'true';